import styled from 'styled-components'

const InputTitle = styled.label`
  display: flex;
  flex-direction: row;
  height: 21px;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  font-size: .9375rem;
`

export default InputTitle
